<ng-template
  [ngIf]="service.IsFeatureEnabled && (((analyzes$ | async) ?? []).length > 0 || (clientEnabled$ | async) ?? false)">
  <div class="ocl-container-with-padding" style="width: 100%; margin-top: 16px">
    <dx-accordion [selectedItem]="-1" [collapsible]="true" [animationDuration]="300">
      <dxi-item title="Interpretation">
        <div>
          <dx-scroll-view [scrollByContent]="true" [scrollByThumb]="true" [height]="250">
            <ng-template [ngIf]="(exists$ | async)" [ngIfElse]="noData">
              <div *ngFor="let analysis of analyzes$ | async">
                <h4>{{analysis.testName}}</h4>
                <p [innerHTML]="analysis.analysis"></p>
              </div>
              <div>
                <h4>Disclaimer</h4>
                <p>These result interpretations are intended for
                  educational purposes only and should not replace medical advice or consultation with a licensed
                  healthcare provider.</p>
              </div>
            </ng-template>
            <ng-template #noData>
              <div>
                <h4>Good news!</h4>
                <p>All your laboratory results are within normal ranges. No further action is required at this time.
                  Please continue with your current
                  health regimen. Regular monitoring remains important for overall health.</p>
              </div>
            </ng-template>
          </dx-scroll-view>
        </div>
      </dxi-item>
    </dx-accordion>
  </div>
</ng-template>
